// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__26mG-","modalForm":"UpgradeEpcsModal_modalForm__3AD6Y","modalFooter":"UpgradeEpcsModal_modalFooter__388gS"};